<template>
  <div
    class="company_container"
    :class="pclass"
    sm="6"
    md="6"
    v-if="item !== null"
  >
    <div class="img_box">
      <img
        :src="imageURL"
        alt="company"
        v-if="imageURL !== null && imageURL !== ''"
      />
      <img :src="companyNoImage" alt="No thumnail of company" v-else />
    </div>
    <div class="widget-bottom">
      <div class="img-description">
        <div class="logo_box">
          <img :src="companyURL" alt="logo" v-if="companyURL !== null" />
          <img :src="companyNoImage" alt="No thumnail of company" v-else />
        </div>
        <div class="box-company">
          <div class="company-name">
            {{ item.company_name }}
          </div>
          <div
            class="company-info"
            v-html="
              item !== null && item.business_content
                ? item.business_content
                : ''
            "
          ></div>
          <div class="company-name">
            {{
              $t('company-detail.title.company-information.office-location', {
                split: '/'
              })
            }}:
          </div>
          <div
            class="company-address"
            v-html="
              item !== null && item.office_location ? item.office_location : ''
            "
          ></div>
        </div>
      </div>

      <div class="box-button">
        <div class="btn-left">
          <v-btn class="com_btn" depressed color="#E8320D">
            <v-icon dark left>mdi-eye-outline</v-icon>
            {{ $t('component.button-detail', { split: '/' }) }}
          </v-btn>
        </div>
        <div class="btn-right">
          <v-btn v-if="type === 'unlike'" depressed class="add-favorite-1">{{
            $t('company-detail.button-remove-from-favorite-company', {
              split: '/'
            })
          }}</v-btn>

          <v-btn v-else depressed class="add-favorite-3">{{
            $t('company-detail.button-add-to-favorite-company', {
              split: '/'
            })
          }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {} from '@/common/constants';
import CompanyNoImage from '@/assets/image/company-no-image.jpg';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      imageURL: null,
      companyURL: null,
      companyNoImage: CompanyNoImage
    };
  },
  name: 'CompanyCardPreview',

  props: {
    item: {
      type: Object
    },
    pclass: {
      type: String
    },
    type: {
      type: String
    }
  },

  watch: {
    item: function (val) {
      if (val !== null) {
        this.imageURL = val.thumbnail !== null ? val.thumbnail : null;
        this.companyURL = val.company_logo !== null ? val.company_logo : null;
      }
    }
  },

  methods: {},

  created() {},

  computed: {
    ...mapGetters({
      favoriteCompany: 'getFavoriteCompanyData'
    })
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/devices.scss';
.company_container {
  background: #f0f7fd;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  width: 100%;
  height: 340px;
  .img_box {
    overflow: hidden;
    position: relative;
    img {
      width: 100%;

      //center alignment
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .label-favorite-company {
      position: absolute;
      background: #ff7a00 !important;
      border-radius: 19px;
      color: #fff;

      right: 17px;
      top: 17px;
      text-transform: unset;
    }
  }

  .widget-bottom {
    display: flex;
    flex-direction: column;
    padding: 21px;
    position: relative;

    .img-description {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;

      .logo_box {
        width: 121px;
        min-width: 121px;
        height: 121px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

        position: relative;
        img {
          height: 100%;
          width: 100%;
        }
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          margin-top: 10px;
          text-align: left !important;
          letter-spacing: 2px;
          font-family: Roboto;
          font-style: normal;
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;

          // white-space: pre-wrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
        }
        span {
          font-weight: bold;
        }
        .company-address {
          display: inline;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      margin-top: 20px;

      .btn-left {
        .com_btn {
          text-transform: unset;
          color: #fff;
          width: 100%;
          border-radius: 8px;
        }
      }
      .btn-right {
        .add-favorite-1 {
          background: #f0f7fd;
          border: 1.5px solid #e8320d;
          box-sizing: border-box;
          border-radius: 8px;
          color: #e8320d;
          text-transform: unset;
        }

        .add-favorite-2 {
          background: #e8320d;
          border: 1.5px solid #e8320d;
          box-sizing: border-box;
          border-radius: 8px;
          color: #fff;
          text-transform: unset;
        }

        .add-favorite-3 {
          border: 1.5px solid #00a2ff;
          box-sizing: border-box;
          border-radius: 8px;
          color: #00a2ff;
          text-transform: unset;
        }
      }
    }
  }
}

@media only screen and (max-width: 320px) {
  .label-favorite-company {
    right: 7px !important;
    width: 235px;
  }
}

@include mobile {
  .company_card {
    width: 100% !important;
    margin-bottom: 32px !important;
    height: auto;
    .img_box {
      .label-favorite-company {
        font-size: 12px;
      }
    }

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
        }
      }
      .btn-right {
        width: 100%;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          width: 100% !important;
        }
      }
    }
  }
}

@include laptop {
  .company_card {
    margin-bottom: 32px !important;
    height: auto;

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
        }
      }
      .btn-right {
        width: 100%;
        overflow: hidden;
        text-overflow: hidden;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          width: 100% !important;
        }
      }
    }
  }
}

@include desktop {
  .company_card {
    margin-bottom: 32px !important;
    height: auto;

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
        }
      }
      .btn-right {
        width: 100%;
        overflow: hidden;
        text-overflow: hidden;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          width: 100% !important;
        }
      }
    }
  }
}

@include ultra {
  .company_card {
    margin-bottom: 32px !important;
    height: auto;

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
        }
      }
      .btn-right {
        width: 100%;
        overflow: hidden;
        text-overflow: hidden;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          width: 100% !important;
        }
      }
    }
  }
}
</style>
